import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@chakra-ui/react';
import { Base } from '../Base';

export const SelectField = forwardRef((props, ref) => {
  const {
    name,
    value,
    error,
    onBlur,
    control,
    onChange,
    children,
    iconColor,
    inputProps,
    isDisabled,
    placeholder,
    'data-testid': dataTestId,
    ...contentProps
  } = props;
  const testid = dataTestId
    ? `${dataTestId}-input`
    : null;

  return (
    <Base
      control={control}
      error={error}
      {...contentProps}
    >
      <Select
        h="12"
        ref={ref}
        name={name}
        value={value}
        onBlur={onBlur}
        borderRadius="xl"
        onChange={onChange}
        isInvalid={!!error}
        data-testid={testid}
        iconColor={iconColor}
        borderColor="gray.400"
        isDisabled={isDisabled}
        placeholder={placeholder}
        errorBorderColor="red.500"
        {...inputProps}
      >
        {children}
      </Select>
    </Base>
  );
});

SelectField.defaultProps = {
  value: '',
  error: null,
  children: null,
  inputProps: {},
  placeholder: '',
  onBlur: () => {},
  'data-testid': '',
  onChange: () => {},
  iconColor: 'gray.500',
};

SelectField.propTypes = {
  onBlur: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.shape({ message: PropTypes.string }),
  children: PropTypes.node,
  onChange: PropTypes.func,
  iconColor: PropTypes.string,
  placeholder: PropTypes.string,
  inputProps: PropTypes.shape({}),
  'data-testid': PropTypes.string,
  name: PropTypes.string.isRequired,
};
